var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"users"}},[_c('nav-bar',{staticClass:"nav-bar",staticStyle:{"top":"0"},attrs:{"current-page":'USERS'}}),_c('user-list')],1)}
var staticRenderFns = []

export { render, staticRenderFns }